"use client";
import { useState } from "react";
import FilterBar from "../components/FilterBar";
import ImageGallery from "../components/ImageGallery";
import VideoCard from "../components/VideoCard";
import DescriptionCard from "../components/DescriptionCard";
import TryOnExample from "../components/TryOnExample";

export default function InspirationGallery() {
  const [image, setImage] = useState("");
  const [video, setVideo] = useState("");
  const [tryOnText, setTryOnText] = useState("Bell-sleeve blouse");
  const [description, setDescription] = useState("A woman wearing a denim midi dress");
  const [openDropdown, setOpenDropdown] = useState(null);

  return (
    <div className="w-full h-screen bg-gradient-to-b from-rose-50 to-amber-50 dark:from-ground dark:to-ground text-white overflow-y-scroll px-4 py-6 relative">
      <FilterBar openDropdown={openDropdown} setOpenDropdown={setOpenDropdown} />

      <div className="columns-1 sm:columns-2 md:columns-3 lg:columns-4 gap-2 space-y-2  ">
        <ImageGallery setImage={setImage} setDescription={setTryOnText} />
        <VideoCard setVideo={setVideo} />
        <TryOnExample image={image} tryOnText={tryOnText} setTryOnText={setTryOnText} />

        <DescriptionCard image={image} description={description} />
      </div>
    </div>
  );
}